export default "__VITE_ASSET__BmzQbAMr__ 584w";